'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    prevText: '上一页',
    nextText: '下一页'
};
module.exports = exports['default'];